module.exports = "https://static.wagwalking.com/_next/static/images/dog-boarding-3-fe7af89058c995b57cbab553430e11d2.svg";